export const CREATE_REQUEST_ENTITY = 'CREATE_REQUEST_ENTITY'
export const UPDATE_REQUEST_ENTITY = 'UPDATE_REQUEST_ENTITY'
export const DELETE_REQUEST_ENTITY = 'DELETE_REQUEST_ENTITY'